import {
  VerifyEmailPayload,
  VerifyEmailResponse,
  VerifyOtpPayload,
  setNotificationEmail as setNotificationEmailApi,
  verifyNotificationEmail as verifyEmailApi,
  verifyNotificationOtp as verifyOtpApi,
} from "utils/AxiosUtil";
import type { NetworkType } from "utils/network";

/** The three legs of turning on transaction-receipt emails: verify the inbox, then store it. */
async function verifyEmail(
  payload: VerifyEmailPayload,
  network: NetworkType,
): Promise<VerifyEmailResponse> {
  return verifyEmailApi(payload, network);
}

async function verifyOtp(payload: VerifyOtpPayload, network: NetworkType) {
  return verifyOtpApi(payload, network);
}

async function setNotificationEmail(
  payload: VerifyEmailPayload,
  network: NetworkType,
) {
  return setNotificationEmailApi(payload, network);
}

const notification_services = { verifyEmail, verifyOtp, setNotificationEmail };
export default notification_services;
